import { z } from 'zod';
/**
 * 解析上下文查詢參數 Schema
 * 用於 GET /api/context/resolve
 */
export const ResolveContextQuerySchema = z.object({
    lineGroupId: z.string().min(1, 'Group ID is required').describe('LINE 群組 ID'),
});
/**
 * 解析上下文回應 Schema
 * 用於 GET /api/context/resolve
 */
export const ResolveContextResponseSchema = z.object({
    status: z.enum(['bound', 'unbound']).describe('綁定狀態'),
    // 當 bound 時回傳 tenant 資訊
    tenant: z.object({
        id: z.string().uuid().describe('Tenant ID'),
        name: z.string().describe('Tenant 名稱'),
        description: z.string().optional().describe('Tenant 描述'),
    }).optional(),
    // 當 unbound 時回傳 group id 確認
    group: z.object({
        id: z.string().describe('LINE 群組 ID'),
    }).optional(),
});
/**
 * 綁定群組請求 Body Schema
 * 用於 POST /api/context/bind
 */
export const BindGroupBodySchema = z.object({
    lineGroupId: z.string().min(1, 'Group ID is required').describe('LINE 群組 ID'),
    tenantId: z.string().uuid('Invalid tenant ID format').describe('Tenant ID'),
});
/**
 * 綁定群組回應 Schema
 * 用於 POST /api/context/bind
 */
export const BindGroupResponseSchema = z.object({
    success: z.boolean().describe('是否成功'),
    binding: z.object({
        id: z.number().int().describe('綁定記錄 ID'),
        lineGroupId: z.string().describe('LINE 群組 ID'),
        tenantId: z.string().uuid().describe('Tenant ID'),
        createdAt: z.string().describe('建立時間（ISO 8601）'),
    }).optional(),
});
/**
 * 使用者擁有的 Tenants 回應 Schema
 * 用於 GET /api/users/me/tenants
 */
export const UserTenantsResponseSchema = z.object({
    tenants: z.array(z.object({
        id: z.string().uuid().describe('Tenant ID'),
        name: z.string().describe('Tenant 名稱'),
        slug: z.string().describe('Tenant 識別碼'),
        description: z.string().optional().describe('Tenant 描述'),
        logoUrl: z.string().url().nullable().optional().describe('Logo URL'),
        isActive: z.boolean().describe('是否啟用'),
    })).describe('使用者擁有的 Tenants 列表（僅限 OWNER 角色）'),
});
/**
 * 新用戶註冊請求 Body Schema
 * 用於 POST /api/auth/register
 */
export const RegisterNewUserBodySchema = z.object({
    groupId: z.string().optional().describe('LINE 群組 ID（可選，如果提供則會查詢對應的 tenantId 並寫入 JWT）'),
    lineIdToken: z.string().min(1, 'LINE ID Token is required').describe('LINE ID Token'),
});
/**
 * 新用戶註冊回應 Schema
 * 用於 POST /api/auth/register（Lite 版本：建立 lite_users 和 lite_groups）
 */
export const RegisterNewUserResponseSchema = z.object({
    success: z.boolean().describe('是否成功'),
    user: z.object({
        id: z.string().uuid().describe('Lite User ID'),
        email: z.string().email().describe('Email'),
        name: z.string().nullable().describe('名稱'),
        avatarUrl: z.string().url().nullable().describe('頭像 URL'),
    }).describe('新建立的 Lite 用戶資訊'),
    tenant: z.object({
        id: z.string().uuid().describe('Lite Tenant ID'),
        name: z.string().describe('租戶名稱'),
    }).describe('新建立的 Lite 租戶資訊'),
    jwtToken: z.string().describe('JWT Token（用於後續認證）'),
});
